var modifierKeyMap = {
    control: 'ctrlKey',
    shift: 'shiftKey',
    alt: 'altKey',
    meta: 'metaKey'
};
export default (function (keys) { return keys.map(function (k) { return modifierKeyMap[k]; }); });



//////////////////
// WEBPACK FOOTER
// ./~/@reecelucas/react-use-hotkeys/esm/helpers/mapModifierKeys.js
// module id = 662
// module chunks = 0